export default "__VITE_ASSET__Dx$37LUt__"